import React from 'react';
import classNames from 'classnames';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { Card, Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { Link } from 'react-router-dom';
import AdvanceTableSearchBox from '../../components/common/advance-table/AdvanceTableSearchBox';
import FooterPaginacionOrdenes from './FooterPaginacionOrdenes'
import PropTypes from 'prop-types';

const TablaDetalleOrdenes = ({
    detallesOrdenes,
    vendedores,
    vendedorID,
    setVendedorID,
    dateQuarter,
    FilterEstatus,
    setFilterEstatus,
    tipoReporte,
    setTipoReporte,
    pageSize,
    setPageSize,
    totalRecords,
    pageNumber,
    setPageNumber,
    idCatTipoUsuario,
    ObtenerDetallesOrden,
    searchFilter,
    onSearchChange
}) => {


    //Columnas
    const columnsDetallesOrden = [
        {
            accessor: 'iNumPagosNoValidados',
            Header: '',
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { iNumPagosNoValidados, idOrden, bComentario, bIsActive } = rowData.row.original;
                return (
                    <>
                        {bIsActive == 0 &&
                            <img title="Hay comentarios" src="/img/noactivo.png"></img>
                        }
                        {iNumPagosNoValidados > 0 &&
                            <Link to={"/ordenes/detalle/" + idOrden}>
                                <img title="Hay pagos sin validar..." src="/img/advertencia20.png"></img>
                            </Link>
                        }
                        {iNumPagosNoValidados == 0 &&
                            <img title="Validado" src="/img/activo.png"></img>
                        }

                        {bComentario == 1 &&
                            <img title="Hay comentarios" src="/img/comentario20.png"></img>
                        }


                    </>
                );
            }
        }, {
            accessor: 'idOrden',
            Header: 'Orden',

            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { idOrden, bIsActive } = rowData.row.original;
                return (
                    <>
                        <Link to={"/ordenes/detalle/" + idOrden} target="_blank">
                        <strong className={classNames({
                                "text-danger": bIsActive == false,
                            })}># {idOrden}</strong>
                        </Link>

                    </>
                );
            }
        },
        {
            accessor: 'vNombreCliente',
            Header: 'Cliente',

            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { idClienteAkasia, vNombreCliente, vEmail, bIsActive } = rowData.row.original;
                return (
                    <>

                        <Link to={"/clientes/detalle/" + idClienteAkasia}>
                            <strong className={classNames({
                                "text-danger": bIsActive == false,
                            })}>{vNombreCliente}</strong> <br />
                        </Link>
                        <span className={classNames({
                            "text-danger": bIsActive == false,
                            "text-lowercase": true
                        })} >{vEmail}</span>
                    </>
                );
            }
        },
        {
            accessor: 'dFechaVenta',
            Header: 'Fecha venta'
        },
        {
            accessor: 'vUsuario',
            Header: 'Vendedor',
            Cell: rowData => {
                const { vUsuario } = rowData.row.original;
                return (
                    <>
                        {vUsuario}
                    </>
                );
            }
        },
        {
            accessor: 'vCodigoBarras',
            Header: 'Codigo Barras',
            Cell: rowData => {
                const { vCodigoBarras } = rowData.row.original;
                return (
                    <>{vCodigoBarras == 'LIC-SERV' &&
                        <img src="/img/servidor48.png" width="32"></img>}
                        {vCodigoBarras == 'LIC-CAJ' &&
                            <img src="/img/caja48.png" width="32"></img>}
                        {vCodigoBarras == 'LIC-NUB' &&
                            <img src="/img/nube48.png" width="32"></img>}
                        {vCodigoBarras == 'POL-BAS' &&
                            <img src="/img/soporte48.png" width="32"></img>}
                        <strong>{vCodigoBarras}</strong>
                    </>
                );
            }
        },
        {
            accessor: 'vNombreProducto',
            Header: 'Nombre Producto',
            Cell: rowData => {
                const { vJsonLicencias, vJsonPolizas, vJsonRenovacion, vCodigoBarras, vNombreProducto, dCantidad } = rowData.row.original;

                //Verificando las licencias vinculadas
                const jsonLicencias = vJsonLicencias;

                const objLicencias = JSON.parse(jsonLicencias);
                let dNumeroLicencias = objLicencias.length;
                const dCantidadComprada = dCantidad;
                let dDiferencia = dCantidadComprada - dNumeroLicencias;

                //Verificando polizas vinculadas
                const jsonPolizas = vJsonPolizas;

                var objPolizas = [];

                objPolizas = JSON.parse(jsonPolizas);
                let dNumeroPolizas = objPolizas.length;
                const dCantidadCompradaPoliza = dCantidad;
                let dDiferenciaPoliza = dCantidadCompradaPoliza - dNumeroPolizas;

                //verificando renovaciones vinculadas
                const jsonLicRen = vJsonRenovacion;

                var objRenovacion = [];

                objRenovacion = JSON.parse(jsonLicRen);
                let dNumeroLicRen = objRenovacion.length;
                const dCantidadCompradaLicRen = dCantidad;
                let dDiferenciaLicRen = dCantidadCompradaLicRen - dNumeroLicRen;


                return (
                    <>
                        <Row>
                            <Col>
                                <span>{vNombreProducto}</span>
                            </Col>
                        </Row>
                        <Row>
                            {objLicencias.map(objLicencia => {
                                return (
                                    <Col key={objLicencia.idLicencia} className="col-6 pr-1 mb-2" style={{ cursor: 'pointer' }}>

                                        <Link to={"/licencias/detalle/" + objLicencia.idLicencia} target="_blank" className="stretched-link text-info position-relative">
                                            <img className="mr-2" src="/img/pcautorizada20.png"></img>
                                            {vCodigoBarras} #{objLicencia.idLicencia}

                                            {
                                                (objLicencia.Status == "NO ACTIVADA") ?
                                                    <span className="ms-2 badge badge-soft-danger">{objLicencia.Status}</span>
                                                    : objLicencia.Status.includes("VC ") ?
                                                        <span className="ms-2 badge badge-soft-warning">{objLicencia.Status}</span>
                                                        :
                                                        <span className="ms-2 badge badge-soft-success">{objLicencia.Status}</span>

                                            }

                                            {
                                                (objLicencia.bCancelado == 1) &&
                                                <>&nbsp;<span className="ms-2 badge badge-soft-danger">CANCELADA</span></>

                                            }


                                        </Link>

                                        {/*<span className="text-muted">Click para <strong>asignar licencia</strong></span>*/}

                                    </Col>
                                );
                            })
                            }
                            {dDiferencia > 0 && (vCodigoBarras == 'LIC-SERV' || vCodigoBarras == 'LIC-CAJ' || vCodigoBarras == 'LIC-NUB') &&
                                <Col><span className="ms-2 badge badge-soft-danger">FALTA ASIGNAR LICENCIAS</span></Col>}
                        </Row>
                        <Row>
                            {
                                objPolizas.map(
                                    (objPoliza, index) => {
                                        return (
                                            (objPoliza.idPoliza > 0) &&
                                            <Col key={index} xs={12} md={12} className="pr-1 mb-2" style={{ cursor: 'pointer' }}>
                                                <img className="mr-2" src="/img/activo.png"></img>

                                                <Link to={"/polizas/detalle/" + objPoliza.idPoliza} target="_blank" className="stretched-link text-info position-relative">

                                                    #{objPoliza.idPoliza}

                                                </Link>
                                                <span className="fs--2"> | {objPoliza.vNombrePoliza}</span>
                                            </Col>



                                        );

                                    }
                                )
                            }
                            {dDiferenciaPoliza > 0 && (vCodigoBarras == 'POL-BAS' || vCodigoBarras == 'POL-EXT') &&
                                <Col><span className="ms-2 badge badge-soft-danger">FALTA RENOVAR PÓLIZA</span>

                                </Col>}
                        </Row>
                        <Row>
                            {
                                objRenovacion.map(
                                    (licRen, index) => {
                                        return (
                                            (licRen.idLicencia > 0) &&
                                            <Col key={index} xs={12} md={6} className="pr-1 mb-2" style={{ cursor: 'pointer' }}>
                                                <img className="mr-2" src="/img/activo.png"></img> <b></b>&nbsp;
                                                <Link to={"/licencias/detalle/" + licRen.idLicencia} target="_blank" className="stretched-link text-info position-relative">
                                                    LIC #{licRen.idLicencia}
                                                </Link>
                                                &nbsp; x {licRen.iNumeroDias} días
                                            </Col>

                                        );

                                    }
                                )
                            }
                            {dDiferenciaLicRen > 0 && (vCodigoBarras == 'LIC-NUB-RENOV' || vCodigoBarras == 'LIC-NUB-MEN') &&
                                <Col><span className="ms-2 badge badge-soft-danger">FALTA RENOVAR LICENCIA</span></Col>}
                        </Row>
                    </>

                );
            }
        },
        {
            accessor: 'dCantidad',
            Header: 'CANT'
        },

        {
            accessor: 'dTotal',
            Header: 'Total',
            Cell: rowData => {
                const { dTotal } = rowData.row.original;
                return (
                    <>
                        <span className="text-end fs--1 fw-medium py-2">${parseFloat(dTotal).toLocaleString("es-MX", {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2
                        })}</span>
                    </>
                );
            }
        },
        {
            accessor: 'vMoneda',
            Header: 'Moneda',
            Cell: rowData => {
                const { vMoneda, dTipoCambio } = rowData.row.original;
                return (
                    <>
                        <span>

                            <span>{vMoneda}</span>
                            <span className="fw-bold">{(vMoneda == 'USD' ? " T.C. " + dTipoCambio : "")}</span>

                        </span>

                    </>
                );
            }
        }
    ];

    return (
        <AdvanceTableWrapper
            columns={columnsDetallesOrden}
            data={detallesOrdenes}
            sortable
            pagination
            perPage={30}
        >
            <Card className="mb-3">
                <Card.Header>
                    <Row>

                        <Col xs={12} sm={6} md={6} lg={3}>
                            <span><Form.Label className="text-700 m-0">Mes</Form.Label> <br /></span>
                            <DatePicker
                                selected={dateQuarter}
                                onChange={(date) => {
                                    console.log(date);
                                    sessionStorage.setItem("selectMes", date);
                                    //setDateQuarter(new Date(date));
                                    ObtenerDetallesOrden(vendedorID, date, 1, pageSize);
                                }}
                                dateFormat="MMMM yyyy - QQQ"
                                className="form-control w-100 m-0"
                                showMonthYearPicker
                            />
                        </Col>

                        <Col xs={12} sm={6} md={6} lg={3} className="align-items-center mb-1">
                            <Form.Label className="text-700 m-0">Vendedores</Form.Label>
                            <Form.Select
                                size="sm"
                                aria-label="Default select"
                                className="form-control m-0"
                                value={vendedorID}
                                onChange={(e) => {
                                    setVendedorID(e.target.value);
                                    sessionStorage.setItem("selectIDUsuario", e.target.value)
                                    //ObtenerOrden(e.target.value, dateQuarter);
                                }}
                                disabled={idCatTipoUsuario != 1}
                            >
                                <option value="">Todos los vendedores</option>
                                {vendedores.map((vendedor, index) => {
                                    return (<option key={index} value={vendedor.idUsuario}>{vendedor.vNombre} {vendedor.vApellidos}</option>)
                                })}

                            </Form.Select>

                        </Col>

                        <Col xs={12} sm={6} md={6} lg={3} className="align-items-center mb-1">
                            <Form.Label className="text-700 m-0">Estatus</Form.Label>
                            <Form.Select
                                size="sm"
                                aria-label="Default select"
                                className="form-control m-0"
                                value={FilterEstatus}
                                onChange={(e) => {
                                    setFilterEstatus(e.target.value);
                                }}

                            >
                                <option value="-1">TODOS</option>
                                <option value="1">Pagadas</option>
                                <option value="0">No Pagadas</option>

                            </Form.Select>

                        </Col>
                        <Col xs={12} sm={6} md={6} lg={3} className="align-items-center mb-1">
                            <Form.Label className="text-700 m-0">Tipo de reporte</Form.Label>
                            <Form.Select
                                size="sm"
                                aria-label="Default select"
                                className="form-control m-0"
                                value={tipoReporte}
                                onChange={(e) => {
                                    setTipoReporte(Number(e.target.value));
                                    setPageNumber(1);
                                }}

                            >
                                <option value="0">&Oacute;RDENES</option>
                                <option value="1">DETALLE DE &Oacute;RDEN</option>

                            </Form.Select>

                        </Col>
                        <Col sm={8} lg={4} xs={12} className="mt-2" >
                            <AdvanceTableSearchBox
                                globalFilter={searchFilter}
                                setGlobalFilter={onSearchChange}
                                placeholder="Buscar orden..."
                            />
                        </Col>
                    </Row>
                </Card.Header>
                <Card.Body className="p-0">
                    <AdvanceTable
                        table
                        headerClassName="bg-200 text-900 text-nowrap align-middle"
                        rowClassName="align-middle white-space-nowrap"
                        tableProps={{
                            size: 'sm',
                            striped: true,
                            className: 'fs--2 mb-0 overflow-hidden'
                        }}
                    />
                </Card.Body>
                <Card.Footer>
                    <FooterPaginacionOrdenes
                        pageSize={pageSize}
                        totalRecords={totalRecords}
                        pageNumber={pageNumber}
                        onPageSizeChange={({ target }) => {
                            setPageSize(Number(target.value));
                            setPageNumber(1);
                        }}

                        onNextPage={() => setPageNumber(pageNumber + 1)}
                        onPreviousPage={() => setPageNumber(pageNumber - 1)}
                        onGotoPage={(val) => setPageNumber(val + 1)}
                    />
                </Card.Footer>
            </Card>
        </AdvanceTableWrapper>
    );

};
TablaDetalleOrdenes.propTypes = {
    detallesOrdenes: PropTypes.array.isRequired,
    vendedores: PropTypes.array.isRequired,
    vendedorID: PropTypes.string,
    setVendedorID: PropTypes.func.isRequired,
    dateQuarter: PropTypes.instanceOf(Date).isRequired,
    FilterEstatus: PropTypes.string.isRequired,
    setFilterEstatus: PropTypes.func.isRequired,
    tipoReporte: PropTypes.number.isRequired,
    setTipoReporte: PropTypes.func.isRequired,
    cargando: PropTypes.bool.isRequired,
    pageSize: PropTypes.number.isRequired,
    setPageSize: PropTypes.func.isRequired,
    totalRecords: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    setPageNumber: PropTypes.func.isRequired,
    idCatTipoUsuario: PropTypes.number,
    ObtenerDetallesOrden: PropTypes.func.isRequired,
    searchFilter: PropTypes.string.isRequired,
    setSearchFilter: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func.isRequired

};

export default TablaDetalleOrdenes;


